import React from "react";

const RequiredSign = ({ className }: any) => {
  return <span className={`text-sm text-red-500 ${className || ""}`}>*</span>;
};

export default RequiredSign;
